import { render, staticRenderFns } from "./QUniqueWritersDrilldown.vue?vue&type=template&id=2f31137c&scoped=true&"
import script from "./QUniqueWritersDrilldown.vue?vue&type=script&lang=js&"
export * from "./QUniqueWritersDrilldown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f31137c",
  null
  
)

export default component.exports